import { jsx as _jsx } from "react/jsx-runtime";
import FooterLink from "../footer-link/footer-link";
import styles from "./footer-links-list.module.css";
var FooterLinksList = function(param) {
    var links = param.links;
    return /*#__PURE__*/ _jsx("ul", {
        className: styles.links,
        children: links.map(function(param) {
            var label = param.label, href = param.href;
            return /*#__PURE__*/ _jsx("li", {
                className: styles.link,
                children: /*#__PURE__*/ _jsx(FooterLink, {
                    label: label,
                    href: href
                })
            }, label);
        })
    });
};
export default FooterLinksList;
